// @ts-nocheck
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import {
    chain,
    DispatchLoadWishListLinesIfNeeded,
    DispatchLoadWishListIfNeeded,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { ApiHandlerDiscreteParameter, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<{ wishListId: string }, GetWishListsApiParameter, OrderModel>;

const getSavedWishListDetailSortBy = (): string | undefined => {
    if (typeof window === "undefined") {
        return undefined;
    }

    const storedValue = window.localStorage.getItem("wishListDetailSortBy");
    if (!storedValue) {
        return undefined;
    }

    try {
        const parsed: unknown = JSON.parse(storedValue);
        return typeof parsed === "string" ? parsed : undefined;
    } catch {
        return storedValue;
    }
};

export const DispatchLoadWishListIfNeededWithFixedCache: HandlerType = props => {
    const wishListState = getWishListState(props.getState(), props.parameter.wishListId);
    if (!wishListState.value) {
        // Store Custom Code - optimziely version checks fields that are always null removing caching mechanism
        props.dispatch(
            loadWishList({
                wishListId: props.parameter.wishListId,
                exclude: ["listLines"],
                expand: ["schedule", "sharedUsers", "favorite", "hidden", "tags"],
            }),
        );
    }
};
export const DispatchLoadWishListLinesIfNeededWithLocalStoragePersistance: HandlerType = props => {
    const savedSortBy = getSavedWishListDetailSortBy();
    const defaultParameter = {
        wishListId: props.parameter.wishListId,
        defaultPageSize: props.getState().context.settings.settingsCollection.wishListSettings.productsPerPage,
        query: "",
        sort: "SortOrder",
    };
    if (!savedSortBy) {
        props.dispatch(updateLoadWishListLinesParameter(defaultParameter));
    } else {
        props.dispatch(updateLoadWishListLinesParameter({ ...defaultParameter, sort: savedSortBy }));
    }

    props.dispatch(loadWishListLines());
};
replaceInChain(chain, DispatchLoadWishListLinesIfNeeded, DispatchLoadWishListLinesIfNeededWithLocalStoragePersistance);
replaceInChain(chain, DispatchLoadWishListIfNeeded, DispatchLoadWishListIfNeededWithFixedCache);
